import styled from 'styled-components';
import { margin } from 'styled-system';
export var Divider = /*#__PURE__*/styled.hr.withConfig({
  displayName: "Divider"
})(["", " border:none;height:", ";color:", ";background-color:", ";"], margin, function (p) {
  return p.theme.border === 'thin' ? '1px' : '2px';
}, function (p) {
  return p.theme.colors.lightContrast;
}, function (p) {
  return p.theme.colors.lightContrast;
});
export default Divider;